import ImageStudent from 'components/ImageStudent'
import React from 'react'

import { Container } from './styles'

interface ProfileTextProps {
  type: string
}

const ProfileText: React.FC<ProfileTextProps> = ({ type }) => {
  return (
    <Container>
      <h1>{type === 'geral' ? 'Meus Dados' : type === 'payment' ? 'Pagamento' : 'Ajuda'}</h1>
      {type === 'geral' ? <ImageStudent /> : null}
      <p>
        {type === 'geral'
          ? 'Altere suas informações gerais e dados de acesso à seu ambiente de aprendizagem.'
          : type === 'payment'
          ? 'Visualize suas faturas de pagamento.'
          : 'Central de ajuda'}
      </p>
    </Container>
  )
}

export default ProfileText
